import React from "react";
import Dropdown from "../../../components/Dropdown";
import SmallerSpinner from "../../../components/SmallerSpinner";
import styles from "../css/inventoryItemDetail.module.css";

// Reusable Text Field Component
export const TextField = ({
  label,
  value,
  onChange,
  className = "",
  compact = false,
  full = false,
  readOnly = false,
  ...props
}) => {
  const fieldClass = `${styles.field} ${compact ? styles.compactField : ""} ${full ? styles.full : ""} ${className}`.trim();

  return (
    <div className={fieldClass}>
      <label>{label}</label>
      <input
        type="text"
        value={value ?? ""}
        onChange={readOnly ? undefined : onChange}
        readOnly={readOnly || !onChange}
        {...props}
      />
    </div>
  );
};

// Reusable Dropdown Field Component
export const DropdownField = ({
  label,
  options,
  value,
  onChange,
  className = "",
  compact = false,
  multiLine = false,
  readOnly = false,
  ...props
}) => {
  const fieldClass = `${styles.field} ${compact ? styles.compactField : ""} ${className}`.trim();
  const labelClass = multiLine ? styles.multiLine : "";

  return (
    <div className={fieldClass}>
      <label className={labelClass}>{label}</label>
      {readOnly ? (
        <input type="text" value={value ?? ""} readOnly {...props} />
      ) : (
        <Dropdown
          options={options}
          value={value}
          onChange={onChange}
          {...props}
        />
      )}
    </div>
  );
};

// Reusable Spinner Field Component
export const SpinnerField = ({
  label,
  value,
  onChange,
  min = 0,
  step = 1,
  ariaLabel,
  className = "",
  compact = false,
  readOnly = false,
  ...props
}) => {
  const fieldClass = `${styles.field} ${compact ? styles.compactField : ""} ${className}`.trim();

  return (
    <div className={fieldClass}>
      <label>{label}</label>
      {readOnly ? (
        <input type="text" value={value ?? ""} readOnly {...props} />
      ) : (
        <SmallerSpinner
          compact={compact}
          value={value}
          onChange={onChange}
          min={min}
          step={step}
          ariaLabel={ariaLabel}
          {...props}
        />
      )}
    </div>
  );
};

// Reusable Textarea Field Component
export const TextareaField = ({
  label,
  value,
  onChange,
  rows = 3,
  className = "",
  full = false,
  readOnly = false,
  ...props
}) => {
  const fieldClass = `${styles.field} ${full ? styles.full : ""} ${className}`.trim();

  return (
    <div className={fieldClass}>
      <label>{label}</label>
      <textarea
        value={value ?? ""}
        onChange={readOnly ? undefined : onChange}
        readOnly={readOnly || !onChange}
        rows={rows}
        {...props}
      />
    </div>
  );
};
